import DashboardLayout from "@pma/app/dashboard/layout";
import { useParams } from "react-router-dom";

import UserProfile from "@components/users/user-profile";

const UsersDetailPage = () => {
  const params = useParams();
  const userId = params?.userId!;

  return (
    <DashboardLayout>
      <UserProfile userId={userId} />
    </DashboardLayout>
  );
};

export default UsersDetailPage;
